import { Check } from 'lucide-react';
import { cx } from '@/cva.config';

export interface StepItem {
  id: string;
  label: string;
}

interface StepperProps {
  className?: string;
  current: number;
  steps: StepItem[];
}

export const Stepper = ({ className, current, steps }: StepperProps) => (
  <ol className={cx('flex items-center gap-2', className)}>
    {steps.map((step, index) => {
      const isActive = index === current;
      const isPast = index < current;
      return (
        <li className="flex flex-1 items-center gap-2" key={step.id}>
          <span
            className={cx(
              'flex size-5 shrink-0 items-center justify-center rounded-full text-xs font-semibold',
              isActive && 'bg-accent text-white',
              isPast && 'bg-score-high text-background',
              !isActive && !isPast && 'bg-border text-subtle',
            )}
          >
            {isPast ? (
              <Check className="size-2.5" strokeWidth={3} />
            ) : (
              index + 1
            )}
          </span>
          <span
            className={cx(
              'text-xs font-medium tracking-wide text-subtle uppercase',
              (isActive || isPast) && 'text-foreground',
            )}
          >
            {step.label}
          </span>
          {index < steps.length - 1 && (
            <span
              className={cx('h-px flex-1 bg-border', isPast && 'bg-score-high')}
            />
          )}
        </li>
      );
    })}
  </ol>
);
